import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import LabelText from './LableText';

const TextArea = (props) => {
  const { label = true, register, placeholder, errors, ...res } = props;
  const name = register.name;
  const labelText = LabelText(name);
  const placeholderText = !label || placeholder ? (placeholder ? placeholder : labelText) : placeholder ? placeholder : labelText;
  return (
    <FormGroup>
      {label && <Label for={name}>{labelText}</Label>}
      <textarea placeholder={placeholderText} {...res} {...register} />
      <ErrorMessage errors={errors} name={name} render={({ message }) => <span style={{ color: 'red' }}>{`${labelText} ${message}`}</span>} />
    </FormGroup>
  );
};

export default TextArea;
